import * as Icons from "lucide-react";

export default function ServiceIcon({ name, className = "w-5 h-5" }) {
  const Icon = Icons[name] || Icons.Circle;
  return <Icon className={className} strokeWidth={1.4} />;
}
